import { ConsoleLogger, Primitive, StorageClient } from '../state/types';

export const decorateStorageWithLogger = (storage: StorageClient, consoleLogger: ConsoleLogger): StorageClient => ({
  createController: <ValueType extends Primitive | Record<string, Primitive> | Primitive[]>(...args: Parameters<StorageClient['createController']>) => {
    const itemName = args[0];
    const controller = storage.createController<ValueType>(...args);

    return {
      get: (...args: Parameters<(typeof controller)['get']>) => {
        const result = controller.get(...args);

        if (result.status === 'success') {
          consoleLogger.debug('storage', 'Item retrieved', { itemName, value: result.value });
        }

        if (result.status === 'error') {
          consoleLogger.error('storage', 'Item could not be retrieved', { itemName, errorType: result.type });
        }

        return result;
      },
      remove: (...args: Parameters<(typeof controller)['remove']>) => {
        const result = controller.remove(...args);

        consoleLogger.debug('storage', 'Item removed', { itemName });

        return result;
      },
      set: (...args: Parameters<(typeof controller)['set']>) => {
        const newValue = args[0];
        const result = controller.set(...args);

        consoleLogger.debug('storage', 'Item set', { itemName, newValue });

        return result;
      },
    };
  },
});
